import { useConfig } from "@megarax/dev-config";
import { AllSignalsPage, MegaraxWebappContainer } from "@megarax/features";
import { HomePage } from "@megarax/home";
import { Navigate, Outlet, Route, Routes, useLocation } from "react-router-dom-v5-compat";

import { LinkDoc } from "@megaron/docs-contracts";
import { getLegacyRedirectPath } from "@megaron/megarax-uri";
import { useClientManager } from "@megaron/react-clients";

import { HistoryPage } from "./history/HistoryPage";
import logo from "./megaronLogo.png";
import { NotFoundPage } from "./notFound/NotFoundPage";
import { useCrmRouter } from "./useCrmRouter";
import { useDevRouter } from "./useDevRouter";
import { useIamRouter } from "./useIamRouter";
import { useInvoicesRouter } from "./useInvoicesRouter";
import { useLoyaltyRouter } from "./useLoyaltyRouter";
import { useSupportRouter } from "./useSupportRouter";

type Props = {
  isAuthLoaded: boolean;
};

export const AppRouter: React.FC<Props> = ({ isAuthLoaded }) => {
  const linkQuery = useClientManager("docs")
    .search()
    .useQuery({ docType: ["link"], limit: 10000 }, { enabled: isAuthLoaded });

  const linkDocs = linkQuery.data?.items as LinkDoc[] | undefined;

  const location = useLocation();
  const pathname = location.pathname;

  const LoyaltyRouter = useLoyaltyRouter();
  const CrmRouter = useCrmRouter();
  const IamRouter = useIamRouter();
  const InvoicesRouter = useInvoicesRouter();
  const SupportRouter = useSupportRouter();
  const DevRouter = useDevRouter();

  if (pathname.endsWith("/") && pathname !== "/") {
    return <Navigate to={pathname.slice(0, -1) + location.search} replace />;
  }

  const legacyPath = getLegacyRedirectPath(pathname, location.search);

  if (legacyPath) {
    return <Navigate to={legacyPath} replace />;
  }

  return (
    <Routes>
      <Route path="/" element={<DefaultMegaraxWebappContainer />}>
        <Route path="" element={<HomePage linkDocs={linkDocs} />} />
        <Route path="history" element={<HistoryPage />} />
        <Route path="signals" element={<AllSignalsPage />} />
        <Route path="*" element={<NotFoundPage />} />
      </Route>

      {LoyaltyRouter}

      {CrmRouter}

      {IamRouter}

      {InvoicesRouter}

      {SupportRouter}

      {DevRouter}
    </Routes>
  );
};

const DefaultMegaraxWebappContainer = () => {
  const { config } = useConfig();

  return (
    <MegaraxWebappContainer
      bypassAuth={config.testUser.enabled}
      title="Megarax.net"
      logo={<img src={logo} alt="Megarax.net" css={{ width: "2rem", height: "2rem" }} />}
    >
      <Outlet />
    </MegaraxWebappContainer>
  );
};
